import { css } from 'twind/css'

export const ratingButton = ({
  rating,
  isRated,
}: {
  rating: number
  isRated: boolean
}) => css`
  height: 44px;
  width: 50px;
  color: ${
    isRated
      ? `${rating === 1 || rating === 2 ? 'var(--business-crimson)' : rating === 4 || rating === 5 ? '#2cc056' : 'var(--gray3)'}`
      : 'var(--gray3)'
  } !important;
  text-align: center !important;
  border-radius: 6px;
  border: ${
    isRated
      ? `2px solid ${rating === 1 || rating === 2 ? 'var(--business-crimson)' : rating === 4 || rating === 5 ? '#2cc056' : 'var(--gray3)'} !important`
      : '1px solid var(--gray5) !important'
  };

  &:hover {
    border-color: ${
      rating === 1 || rating === 2
        ? 'var(--business-crimson)'
        : rating === 4 || rating === 5
          ? '#2cc056'
          : 'var(--gray3)'
    } !important;
    color: ${
      rating === 1 || rating === 2
        ? 'var(--business-crimson)'
        : rating === 4 || rating === 5
          ? '#2cc056'
          : 'var(--gray3)'
    } !important;
  }
`

export const ratingTips = (prop?: { satisfied?: boolean }) => css`
  color: ${prop?.satisfied === true ? '#2cc056' : 'var(--business-crimson)'};
`
